module.exports = __webpack_public_path__ + "img/67.773fc04e.jpg";